import { Item } from './Item';

export class Widget {
	public recommendationItems: Item[];
	public html: string;
	public widgetGuid: string;
	public widgetName: string;
	public widgeTitle: string;
	public widgetCssClass: string;
	public isCarousel: boolean;
	public carouselData: CarouselData;
	public isVertical: boolean;
	public itemsCount: number;

	public constructor(init: Widget) {
		Object.assign(this, init);
		this.recommendationItems = init.recommendationItems.map((r) => new Item(r));
	}
}

export class CarouselData {
	public showNextPrevButtons: boolean;
	public autoRotate: boolean;
	public autoRotateSpeed: number;
	public animationSpeed: number;
	public nofVisible: number;
	public isCircular: boolean;
	public scrollNumber: number;
	public showDots: boolean;
	public enableResponsive: boolean;
	public responseiveConfig: string;
}
